import React from "react";

const ConstraintWarning = ({ warning, onClose }) => {
  return (
    <div
      style={{
        backgroundColor: "#ff9800",
        color: "white",
        padding: "12px 16px",
        borderRadius: "6px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        maxWidth: "90vw",
        width: "fit-content",
        position: "relative",
        marginBottom: "12px",
      }}
    >
      {/* Header row */}
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "6px" }}
      >
        <span style={{ fontSize: "16px", marginRight: "8px" }}>⚠️</span>
        <strong>
          {warning.part} Exceeds {warning.printer} Size
        </strong>
      </div>

      {/* Details */}
      <div style={{ fontSize: "13px" }}>
        {warning.currentSize && (
          <div>
            Current: {warning.currentSize.width} × {warning.currentSize.height}{" "}
            × {warning.currentSize.depth} mm
          </div>
        )}
        {warning.maxSize && (
          <div>
            Printer Max: {warning.maxSize.width} × {warning.maxSize.height} ×{" "}
            {warning.maxSize.depth} mm
          </div>
        )}
{warning.type === "size_exceeded" && (
  <div style={{ 
    marginTop: "4px", 
    color: "#b00", 
    fontWeight: "500",
    maxWidth: "250px", // 或者你觉得合适的宽度
    lineHeight: "1.4"
  }}>
    Recommendation: Scale down the model, switch to a larger printer, or
    split the model or use an alternative workflow.
  </div>
)}
      </div>

      {/* Close button */}
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
          background: "none",
          border: "none",
          color: "white",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        ×
      </button>
    </div>
  );
};

export default ConstraintWarning;
